module.exports = __webpack_public_path__ + "static/fonts/Fact-Italic.c90201b.eot";